import React, { useCallback, useEffect, useRef, useState } from "react";
import { DatePicker, NotifList } from "../../Components/Molecules";
import "./styles.css";
import { Select, Title } from "../../Components/Atoms";
import { Spinner, useToast } from "@chakra-ui/react";
import { ONE_DAY_MS } from "../../Library/constants";
import { throttle } from "lodash";
import { DownloadIcon } from "../../Assets/images/svgs";

const Notifications = ({ fromDrawer }) => {

  const Toast = useToast();
  const [ vehOptions, setVehOptions ] = useState([]);
  const [ alertOptions, setAlertOptions ] = useState([]);
  const [ selectedVehs, setSelectedVehs ] = useState([]);
  const [ selectedAlerts, setSelectedAlerts ] = useState([]);
  const [ selectedDate, setSelectedDate ] = useState({});
  const [fetchingTlEventData, setFetchingTlEventData] = useState(false);

  const scrollHandlerRef = useRef(null);
  const notifListRef = useRef(null);

  const handleNotifFilterOptions = ({ vehs, alerts }) => {
    setVehOptions(vehs);
    setAlertOptions(alerts);
    setSelectedVehs(vehs.map(veh => veh.value));
    setSelectedAlerts(alerts.map(alert => alert.value));
  }

  useEffect(() => {
    setSelectedDate({ from: new Date().setHours(0, 0, 0, 0), to: Date.now() });

    global.EE.addEventListener(global.EE.EVENT_TYPES.NOTIF_FILTER_OPTIONS, handleNotifFilterOptions);
    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.NOTIF_FILTER_OPTIONS, handleNotifFilterOptions);
    };
  }, []);

  const handleDateChange = (date) => {
    let diff = (date.toTs - date.fromTs);
    if ((diff / ONE_DAY_MS) > 30) return Toast({ isClosable: true, description: "Date range should not be greater than 30 days", position: "bottom", variant: "subtle", duration: 1500 });

    setSelectedDate({ from: date.fromTs, to: date.toTs });
    if (notifListRef.current) notifListRef.current.callFetchTlEvents({ from: date.fromTs, to: date.toTs });
  };

  const handleScroll = useCallback(() => {
    const container = document.querySelector(".panel-notifications");
    if (!container || fetchingTlEventData) return;

    const scrollPosition = container.scrollTop + container.clientHeight;
    const scrollThreshold = container.scrollHeight - 20;

    if (scrollPosition >= scrollThreshold) {
      global.EE.emitEvent(global.EE.EVENT_TYPES.FETCH_TL_EVENTS, { scrollPos: container.scrollTop }, selectedDate );
    }
  }, [fetchingTlEventData, selectedDate]);

  useEffect(() => {
    const container = document.querySelector(".panel-notifications");
    if (!container) return;

    if (!scrollHandlerRef.current) {
      scrollHandlerRef.current = throttle(handleScroll, 250);
    }

    container.addEventListener("scroll", scrollHandlerRef.current);

    return () => {
      if (scrollHandlerRef.current) {
        container.removeEventListener("scroll", scrollHandlerRef.current);
        scrollHandlerRef.current.cancel();
        scrollHandlerRef.current = null;
      }
    };
  }, [handleScroll]);

  if (fromDrawer) {
    return <NotifList selectedDateRange={selectedDate} ref={notifListRef} selectedVehs={selectedVehs || []} selectedAlerts={selectedAlerts || []} full={false} fetchingTlEventData={fetchingTlEventData} setFetchingTlEventData={setFetchingTlEventData}/>
  }

  return (
    <section className="panel-main">
      <div className="notif-header">
        <div className="notif-filters">
          <Select defaultOption={"All Vehicles"} selected={selectedVehs} selectAll={{ label: "All Vehicles" }} options={vehOptions} onChange={(selected) => setSelectedVehs(selected)} multi={true} />
          <Select defaultOption={"All Alerts"} selected={selectedAlerts} selectAll={{ label: "All Alerts" }} options={alertOptions} onChange={(selected) => setSelectedAlerts(selected)} multi={true} />
        </div>
        <DatePicker showDefaultRanges={false} showToday={true} onSave={handleDateChange} />
      </div>
      <div className="notif-title-cnt">
        <Title>Notifications</Title>
        <DownloadIcon className="notif-down-icon" onClick={() => notifListRef.current?.downloadNotifications()} />
      </div>
      <div className="panel-notifications panel-card">
        <NotifList selectedDateRange={selectedDate} ref={notifListRef} selectedVehs={selectedVehs || []} selectedAlerts={selectedAlerts || []} full fetchingTlEventData={fetchingTlEventData} setFetchingTlEventData={setFetchingTlEventData}/>
        {fetchingTlEventData ? <div className="notif-spinner-cnt">
          <Spinner className="notif-spinner" size="lg" />
        </div> : null}
      </div>
    </section>
  );
};

export default Notifications;
